import Api from "./Api";
import { environment } from "../environments/env";

export default {
    GetLink(arr) {
        return Api.post(`${environment.apiWebhook}`, arr);
    },
}
